	import errorMessages from "utils/validation/errorMessages";
	import { emailSchema, phoneOptionalSchema, phoneRequiredSchema, select2RequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
	import { array, object, string } from 'yup';

	const addTherapistFormSchema = object().shape({
		firstname: stringRequiredSchema,
		lastname: stringRequiredSchema,
		// username: stringRequiredSchema,
		phone: phoneRequiredSchema,
		email: stringRequiredSchema,
		discipline_id: select2RequiredSchema,
		type: stringRequiredSchema,
		designation_id: select2RequiredSchema,
		registration_number: stringOptionalSchema,
		insurance_policy_number: stringOptionalSchema,
		assigned_client_category: array().required(errorMessages.required).of(select2RequiredSchema).min(1, errorMessages.required),
		calendly_link: stringOptionalSchema,
		self_description: stringOptionalSchema,
		profile_picture: stringOptionalSchema.url(errorMessages.url),
		email_signature: stringOptionalSchema,
		signature_img: stringOptionalSchema.url(errorMessages.url),
		status: stringRequiredSchema,
		timezone: select2RequiredSchema,
		documents: array().of(object().shape({
			attachment_key: stringRequiredSchema,
			attachment_name: stringRequiredSchema
		})),
	});

	export default addTherapistFormSchema;